import React, { memo, Suspense } from 'react';
import { ThemeProvider } from 'fronton-react';
import { AtServer, InBrowser } from 'common/components';
import { Router } from './router';

import './common/styles/base.css';

export const App = memo(() => (
	<ThemeProvider>
		<InBrowser>
			<Suspense fallback={null}>
				<Router />
			</Suspense>
		</InBrowser>
		<AtServer>
			<Router />
		</AtServer>
	</ThemeProvider>
));
